import React from "react";
import { array, object, bool, string } from "prop-types";
import { connect } from "react-redux";
import get from "lodash/get";

import RelatedStory from "../../atoms/RelatedStory";
import { staticTexts } from "../../utils/Translate";

import "./relatedStories.m.css";

const RelatedStories = ({ stories, lang, isMobile, story }) => {
  const relText =
    story && story["story-template"] === "photo"
      ? staticTexts(lang).morePhotoStories
      : staticTexts(lang).relatedStories;
  const wrapperClass =
    story && story["story-template"] === "photo" ? "photo-related-stories-wrapper" : "related-stories-wrapper";
  const storyClass = story && story["story-template"] === "photo" ? "photo-related-story" : "related-story";

  const storyType = (story && story["story-template"]) || "";

  return (
    <div styleName="related-stories">
      <h2 styleName="related-story-heading">{relText}</h2>
      <div styleName={wrapperClass}>
        {stories.map((story) => {
          return (
            <RelatedStory
              storyType={storyType}
              story={story}
              key={story.id}
              isMobile={isMobile}
              storyClass={storyClass}
            />
          );
        })}
      </div>
    </div>
  );
};

RelatedStories.propTypes = {
  stories: array.isRequired,
  lang: string,
  isMobile: bool,
  story: object,
};

const mapStateToProps = (state) => ({
  string: get(state, ["qt", "config", "publisher-attributes", "lang"], ""),
});

export default connect(mapStateToProps)(RelatedStories);
